<template>
  <div class="page">
    <Layout>
      <div class="header">
        <div class="nav">
          <Row type="flex" justify="end" class="code-row-bg view-section">
            <Col class="flex-1">
              <NeoNavMenu :ucapi="config.api.uc" :cimsapi="config.api.cims" :siteFormat="siteFormat" productName="cims" />
            </Col>
            <Col>
              <Dropdown class="menu" placement="bottom-start" id="userCenter">
                <a href="javascript:void(0)">
                  Hi：
                  <span class="user-name">{{ userName }}</span>
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <Row>
                    <Col span="8">
                      <img class="user-pic" :src="`${appPrefix + userPic}`" alt="" />
                    </Col>
                    <Col span="16">
                      <div class="name">{{ userName }}</div>
                      <div class="user-center">
                        <a :href="userCenter">{{ $t('nav.person') }}</a>
                        <a :href="appPrefix + '/message'">
                          {{ $t('nav.message') }}
                          <span>{{ unreadMessageCount }}</span>
                        </a>
                      </div>
                    </Col>
                  </Row>
                  <div class="menu-title">{{ $t('nav.my') }}</div>
                  <Row class="menu-item" type="flex">
                    <Col v-if="roles.REQUEST">
                      <a :href="appPrefix + '/request'">{{ $t('nav.request') }}</a>
                    </Col>
                    <Col v-if="roles.APPLY">
                      <a :href="appPrefix + '/applicant'">{{ $t('nav.purchaseReq') }}</a>
                    </Col>
                    <Col v-if="roles.PURCHASE">
                      <a :href="appPrefix + '/purchase'">{{ $t('nav.purchase') }}</a>
                    </Col>
                    <Col>
                      <a :href="appPrefix + '/projects'">{{ $t('nav.projects') }}</a>
                    </Col>
                    <Col>
                      <a :href="appPrefix + '/favorite'">{{ $t('nav.favorite') }}</a>
                    </Col>
                  </Row>
                  <div class="menu-title" v-if="roles.ORDERAPPROVE || roles.APPLYAPPROVE">
                    <i class="audit-small-icon"></i>
                    {{ $t('nav.approve') }}
                  </div>
                  <Row class="menu-item" type="flex">
                    <Col v-if="roles.ORDERAPPROVE">
                      <a :href="appPrefix + '/requestApprove'">{{ $t('nav.requestApprove') }}</a>
                    </Col>
                    <Col v-if="roles.ORDERAPPROVE" style="margin-right: 8px">
                      <a :href="appPrefix + '/splitApprove'">{{ $t('key92') }}</a>
                    </Col>
                    <Col v-if="roles.APPLYAPPROVE">
                      <a :href="appPrefix + '/applicantApprove'">{{ $t('nav.applicantApprove') }}</a>
                    </Col>
                  </Row>

                  <div class="menu-title">
                    <i class="borrow-small-icon"></i>
                    {{ $t('nav.borrow') }}
                  </div>
                  <Row class="menu-item" type="flex">
                    <Col>
                      <a :href="appPrefix + '/borrow'">{{ $t('nav.myBorrow') }}</a>
                    </Col>
                    <Col>
                      <a :href="appPrefix + '/borrow/post'">{{ $t('nav.post') }}</a>
                    </Col>
                  </Row>

                  <div class="menu-title" v-if="roles.REQUEST || roles.ORDERAPPROVE">
                    <i class="static-small-icon"></i>
                    {{ $t('nav.statistic') }}
                  </div>
                  <Row class="menu-item" type="flex">
                    <Col v-if="roles.REQUEST">
                      <a :href="appPrefix + '/requestStatistic'">{{ $t('nav.requestStatistic') }}</a>
                    </Col>
                    <Col v-if="roles.ORDERAPPROVE">
                      <a :href="appPrefix + '/approveStatistic'">{{ $t('nav.approveStatistic') }}</a>
                    </Col>
                  </Row>
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col class="logout" v-if="!isDingTalkEnv()">
              <div @click="logout">{{ $t('nav.logout') }}</div>
            </Col>
            <Col>
              <i class="waste-icon"></i>
              <a :href="appPrefix + '/waste'" style="line-height: 34px; color: #999">{{ $t('nav.waste') }}</a>
            </Col>
          </Row>
        </div>
        <div class="search-wrapper">
          <div class="search" id="search" :class="{ fixed: fixed }">
            <Row class="view-section" type="flex" justify="space-between">
              <Col>
                <a :href="appPrefix">
                  <img src="@/assets/img/logo.png" class="logo" alt="" />
                </a>
              </Col>
              <Col class="flex-1">
                <div type="flex" class="search-section" id="searchSection">
                  <input
                    v-model="keywords"
                    autocomplete="off"
                    spellcheck="false"
                    type="text"
                    :placeholder="$t('nav.search')"
                    class="ivu-input ivu-input-default search-input"
                    @keyup.enter="search"
                  />
                  <div class="search-btn" :class="{ active: searchBtnIndex === 1 }" @click="search">
                    <Icon type="ios-search" />
                    <span v-if="searchBtnIndex === 1">{{ $t('btn.search') }}</span>
                  </div>
                  <Dropdown trigger="click" placement="bottom-end" class="ketcher-switch">
                    <div class="structure-search-btn" :class="{ active: searchBtnIndex === 2 }">
                      <span class="structure-search-icon" @click="searchBtnIndex = 2" />
                      <span v-if="searchBtnIndex === 2">{{ $t('key53') }}</span>
                    </div>
                    <DropdownMenu class="ketcher-content" slot="list">
                      <iframe
                        :src="`/drawweb/?loadHelmLibWhenNeed=true&hiddenToggler=true&hiddenControls=settings`"
                        class="ketcher-panel"
                        id="ketcher-id"
                        title="iLabPowerDraw"
                      />
                      <div class="clear"></div>
                      <RadioGroup v-model="structSearchType" size="large">
                        <Radio :label="0">{{ $t('page.childStructSearch') }}</Radio>
                        <Radio :label="1">{{ $t('page.exactSearch') }}</Radio>
                        <Radio :label="2">{{ $t('page.similarSearch') }}</Radio>
                      </RadioGroup>
                      <Select v-model="percent" class="search-percent" size="small" v-show="structSearchType === 2">
                        <Option :value="0.6" :key="1">0.6</Option>
                        <Option :value="0.7" :key="2">0.7</Option>
                        <Option :value="0.8" :key="3">0.8</Option>
                        <Option :value="0.9" :key="4">0.9</Option>
                        <Option :value="1.0" :key="5">1.0</Option>
                      </Select>
                      <Button class="ketcher-search-btn" @click="searchStructure" :loading="subSearchLoading">
                        <i></i>
                        <span v-if="searchBtnIndex === 2">{{ $t('nav.structSearch') }}</span>
                      </Button>
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown trigger="click" placement="bottom-end" class="advanced-search">
                    <div class="advanced-search-btn" :class="{ active: searchBtnIndex === 3 }" @click="advanceSearch">
                      <Icon type="ios-locate-outline" />
                      <span v-if="searchBtnIndex === 3">{{ $t('key54') }}</span>
                    </div>
                    <DropdownMenu class="ketcher-content" slot="list">
                      <advance-search-form />
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </Col>
              <Col>
                <a :href="appPrefix + '/cart'" class="shop-cart">
                  <i class="cart-ico"></i>
                  <!-- <span>{{$t('nav.cart')}}</span>-->
                  <span id="cart-number" v-if="shoppingCartCount > 0">({{ shoppingCartCount }})</span>
                </a>
              </Col>
            </Row>
          </div>
        </div>
        <div class="breadcrumb" v-if="breadcrumbs.length">
          <div class="view-section">
            <!--                    {{$t('nav.location')}}：-->
            <span>
              <a :href="`${appPrefix}/`">{{ $t('nav.home') }}</a>
            </span>
            <span v-for="item in breadcrumbs" :key="item.txt" :value="item.href">
              <Icon type="ios-arrow-forward" />
              <a :href="appPrefix + item.href" v-if="item.href">{{ item.txt }}</a>
              <span v-else>{{ item.txt }}</span>
            </span>
          </div>
        </div>
      </div>
      <Content class="view-section">
        <slot name="content" ref="content"></slot>
        <div id="fixed-slider-menu">
          <div class="menu-item">
            <a :href="appPrefix + '/favorite'">
              <Icon type="md-star-outline" />
            </a>
            <a :href="appPrefix + '/favorite'" class="menu-item-tip">{{ $t('nav.myFavorite') }}</a>
            <span class="sub-num" v-if="favoriteCount">{{ favoriteCount }}</span>
          </div>
          <div class="menu-item my-cart transition" id="sliderCart">
            <a :href="appPrefix + '/cart'">
              <img src="../assets/img/sliderC.png" alt="" />
            </a>
            <a class="menu-item-tip" :href="appPrefix + '/cart'">{{ $t('nav.cart') }}</a>
            <span class="sub-num" v-if="shoppingCartCount > 0">{{ shoppingCartCount }}</span>
          </div>
          <div class="menu-item">
            <a :href="appPrefix + '/message'">
              <img src="../assets/img/sliderM.png" alt="" />
            </a>
            <a :href="appPrefix + '/message'" class="menu-item-tip">{{ $t('nav.myMessage') }}</a>
            <span class="sub-num" v-if="unreadMessageCount > 0">{{ unreadMessageCount }}</span>
          </div>
          <div class="menu-item" id="goback-top" @click="gobackTop" v-show="fixed">
            <Icon type="ios-arrow-dropup" />
            <span class="menu-item-tip">{{ $t('page.toTop') }}</span>
          </div>
        </div>
      </Content>
      <Footer>
        <Row type="flex" class="view-section">
          <Col span="24" style="text-align: center">
            {{ $t('page.copyright', [new Date().getFullYear()]) }}
            <span @click="showVersion">V{{ version }}</span>
          </Col>
        </Row>
      </Footer>
    </Layout>
    <neo-lock-screen v-if="!isSSO" :api-prefix="config.api.uc" :domain-control="config.domainLogin" :login-address="logoutUrl"></neo-lock-screen>
    <neo-no-auth :login-address="logoutUrl" :api-prefix="config.api.uc" :domain-control="config.domainLogin" :isSso="isSSO"></neo-no-auth>
  </div>
</template>

<script>
  import neoLockScreen from 'neo-lock-screen';
  import 'neo-lock-screen/dist/style.css';
  import neoNoAuth from 'neo-no-auth';
  import 'neo-no-auth/dist/style.css';
  import utils from '@/utils/utils';
  import { isDingTalkEnv } from '@/utils/utils';
  import api from '@/api';
  import version from '@neotrident/version';
  import logo from '../assets/img/cims-logo.png';
  import { business } from 'neo-utils';
  import NeoNavMenu from 'neo-nav-menu';
  import AdvanceSearchForm from './advanceSearchForm.vue';

  export default {
    name: 'layout',
    components: {
      neoLockScreen,
      neoNoAuth,
      NeoNavMenu,
      AdvanceSearchForm,
    },
    props: {
      breadcrumbs: {
        type: Array,
        default() {
          return [];
        },
      },
      searchIndex: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        config,
        appPrefix: utils.getAppPrefix(),
        userCenter: `${config.site.uc}/#/info`,
        userName: utils.getUserInfo('name'),
        userPic: utils.getUcInfo().AccountInfo ? utils.getUcInfo().AccountInfo.Photo : '',
        unreadMessageCount: 0,
        favoriteCount: 0,
        keywords: '',
        fileType: '0',
        shoppingCartCount: 0,
        roles: utils.getCimsInfo().RoleCodes || {},
        fixed: false,
        noAuth: {
          modal: false,
          message: '',
        },
        structSearchType: 0,
        percent: 0.8,
        subSearchLoading: false,
        searchBtnIndex: this.searchIndex,
      };
    },
    computed: {
      VERSION() {
        return config.version || process.env.VUE_APP_VERSION;
      },
      // 版本号取前两位
      version() {
        return this.VERSION.split('.').slice(0, 2).join('.');
      },
      isSSO: () => utils.isSSO(),
      logoutUrl: () => utils.getSystemLogoutUrl(),
    },
    methods: {
      isDingTalkEnv,
      // 显示版本号
      showVersion() {
        version.open({
          product: {
            name: 'CIMS',
            logo: logo,
            web: {
              value: this.VERSION,
            },
            api: {
              value: config.apiVersion,
            },
            update: config.updateDate,
            lang: business.getLanguage(),
          },
        });
      },
      /**
       * @description 获取未读消息数据
       */
      async fetchUnreadMessageData() {
        const resp = await api.cims.fetchUnreadMessageData();
        if (resp.code == process.env.VUE_APP_code) {
          this.unreadMessageCount = resp.response;
        }
      },
      /**
       * @description 获取我的收藏数据
       */
      async getFavoriteCount() {
        const resp = await api.cims.getFavoriteCount();
        if (resp.code == process.env.VUE_APP_code) {
          this.favoriteCount = resp.response;
        }
      },
      /**
       * @description 获取领用车数据
       */
      async fetchShoppingCartData() {
        const resp = await api.cims.fetchShoppingCartData();
        if (resp.code == process.env.VUE_APP_code) {
          this.shoppingCartCount = resp.response;
        }
      },
      /**
       * @description 我的收藏数量+1
       */
      async setFavoriteCount(count = 1) {
        await utils.sleep(900);
        this.favoriteCount += count;
      },
      /**
       * @description 领用车数量+1
       */
      async setCartCount(count = 1) {
        await utils.sleep(900);
        this.shoppingCartCount += count;
      },
      /**
       * @description 退出系统
       */
      async logout() {
        const exist = utils.isUcCookieExist();
        if (exist) {
          const resp = await api.system.logout();
          if (resp.code == process.env.VUE_APP_code) {
            utils.turnToLoginPage(true);
          } else {
            this.$Message.error(resp.message);
          }
        } else {
          utils.turnToLoginPage(true);
        }
      },
      /**
       * @description 全文搜索
       */
      search() {
        if (this.searchBtnIndex !== 1) {
          this.searchBtnIndex = 1;
          return;
        }
        if (this.keywords) {
          utils.skipTo(`/search?keywords=${this.keywords}`);
        } else {
          utils.skipTo('/search');
        }
      },
      /**
       * @description 结构式搜索
       */
      async searchStructure() {
        this.searchBtnIndex = 2;
        let molecule = utils.getMolfile();
        let smiles = utils.getSmiles();
        if (smiles) {
          this.subSearchLoading = true;
          const resp = await api.mol.search({
            molecule,
            molSearchType: this.structSearchType,
            bottom: this.structSearchType === 2 ? this.percent : 0.0,
          });
          let materielIds = [];
          if (resp.code == process.env.VUE_APP_code) {
            materielIds = resp.response;
          }
          this.$session.set('materielIds', materielIds);
          utils.skipTo('/search?molSerch=true');
        }
      },
      bodyScroll() {
        window.onscroll = () => {
          this.fixed = (document.documentElement.scrollTop || document.body.scrollTop) > 34;
        };
      },
      //设置站点title
      setSiteTitle() {
        document.getElementById('title').innerText = this.$i18n.t('page.pageTitle');
      },
      // 回到页面顶部
      gobackTop() {
        utils.scrollToTop();
      },
      // site匹配,config中不存在时则使用接口中定义的站点地址
      siteFormat(key) {
        return config.site[key];
      },
      advanceSearch() {
        this.searchBtnIndex = 3;
      },
    },
    created() {
      this.keywords = decodeURIComponent(utils.getParams('keywords'));
    },
    mounted() {
      this.setSiteTitle();
      this.bodyScroll();
      this.fetchUnreadMessageData();
      this.fetchShoppingCartData();
      this.getFavoriteCount();
    },
  };
</script>

<style lang="less" scoped>
  @-moz-keyframes email-animation {
    0% {
      color: #999999;
    }

    40% {
      color: #f96100;
    }

    100% {
      color: #f96100;
    }
  }

  @keyframes email-animation {
    0% {
      color: #999999;
    }

    40% {
      color: #f96100;
    }

    100% {
      color: #f96100;
    }
  }

  @-webkit-keyframes email-animation {
    0% {
      color: #999999;
    }

    40% {
      color: #f96100;
    }

    100% {
      color: #f96100;
    }
  }

  .page {
    .vue2-neo-nav-menu {
      /deep/ .neo-menu-app-wrap {
        height: 35px !important;
        margin-top: -1px;
        &:hover {
          .vue2-neo-nav-menu-iconfont.icon-app {
            color: #1388ff !important;
          }
        }
        > .card {
          z-index: 20240606;
        }
      }
      /deep/ .vue2-neo-nav-menu-iconfont.icon-app {
        color: #ddd !important;
      }

      /deep/ .card {
        top: 30px;
      }
    }
    .header {
      .nav {
        width: 100%;
        height: 35px;
        background: #f8f8f8;
        border-bottom: 1px solid #e9e9e9;

        > div {
          background: #f8f8f8;

          > div {
            font-size: 15px;
            color: #999;
            cursor: pointer;
          }

          .menu {
            color: #999;
            margin-right: 6px;

            /deep/ .ivu-dropdown-rel {
              padding: 0 12px;
              line-height: 34px;

              a {
                color: #999;
              }

              .user-name {
                display: inline-block;
                padding-left: 4px;
              }
            }

            /deep/ .ivu-select-dropdown {
              margin: 0;
              padding: 10px 15px;
              border-radius: 0;
              width: 270px;

              .ivu-dropdown-menu {
                > .ivu-row {
                  margin: 0 0 10px 5px;
                }
              }

              .user-pic {
                width: 50px;
                height: 50px;
                border-radius: 100%;
              }

              .name {
                color: #9e9e9e;
                font-size: 14px;
                font-weight: bold;
                line-height: 28px;
                margin-top: 7px;
              }

              .user-center {
                text-align: left;
                line-height: 16px;

                a {
                  color: #999;
                  display: inline-block;
                  margin-right: 5px;
                }

                span {
                  color: #ef0216;
                }
              }

              a:hover {
                text-decoration: underline;
              }

              .menu-title {
                color: #686868;
                font-weight: bold;
                margin: 0 0 10px 5px;
                line-height: 16px;

                .audit-small-icon {
                  display: inline-block;
                  background: url(../assets/img/index_icon.png) -71px -7px no-repeat;
                  width: 17px;
                  height: 19px;
                  background-position: -72px -33px;
                  top: -2px;
                  margin-right: 1px;
                  position: relative;
                }

                .static-small-icon {
                  display: inline-block;
                  width: 18px;
                  height: 20px;
                  background: url(../assets/img/index_icon.png) -8px -35px no-repeat;
                  position: relative;
                  top: 1px;
                  margin-right: 1px;
                }

                .borrow-small-icon {
                  display: inline-block;
                  background: url(../assets/img/index_icon.png) -38px -8px no-repeat;
                  position: relative;
                  width: 18px;
                  height: 20px;
                  background-position: -40px -34px;
                }
              }

              .menu-item {
                color: #9e9e9e;
                margin: 0 0 10px 5px;

                .ivu-col {
                  flex: 1;
                }

                a {
                  color: #999;
                  white-space: nowrap;
                }
              }
            }

            &:hover {
              background-color: #ffffff;

              .ivu-dropdown-rel {
                a {
                  color: #1388ff;
                }
              }
            }
          }

          .logout {
            margin-right: 12px;
            line-height: 34px;

            &:hover {
              color: #ff0000;
            }
          }

          .waste-icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(../assets/img/index_icon.png) -230px -30px no-repeat;
            position: relative;
            top: 3px;
            margin-right: 2px;

            + a:hover {
              text-decoration: underline;
            }
          }

          .ivu-icon-md-mail {
            font-size: 23px;
            line-height: 34px;

            &.active {
              -moz-animation: email-animation 1s ease-in 0.5s infinite;
              -o-animation: email-animation 1s ease-in 0.5s infinite;
              animation: email-animation 1s ease-in 0.5s infinite;
              -webkit-animation: email-animation 1s ease-in 0.5s infinite;
            }
          }

          .liquor-collection {
            margin-left: 12px;
            line-height: 34px;

            a {
              color: #999;
            }

            i {
              display: inline-block;
              width: 20px;
              height: 20px;
              background: url(../assets/img/index_icon.png) -230px -30px no-repeat;
              position: relative;
              top: 3px;
              margin-right: 2px;
            }
          }
        }
      }
    }

    .search-wrapper {
      height: 143px;
      background-color: #ffffff;
    }

    .search {
      height: 143px;
      border-bottom: 1px solid #e9e9e9;
      background-color: #ffffff;
      position: static;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1001;

      &.fixed {
        position: fixed;
        box-shadow: 0 0 5px #888;
      }

      .logo {
        margin: 28px 30px 0 0;
      }

      .view-section {
        > .ivu-col:first-child {
          width: 243px;
        }

        > .ivu-col:last-child {
          width: 170px;
        }
      }

      .search-section {
        margin-top: 38px;
        border: 2px solid #dddddd;
        height: 44px;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;

        > .ivu-col:last-child {
          .ivu-input-search {
            width: 140px;
            line-height: 40px;
            font-size: 16px;
          }
        }

        .search-btn {
          line-height: 34px;
          border-radius: 4px;
          font-size: 16px;
          border: none;
          padding: 0;
          color: #dcdee2;
          text-align: center;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          &.active {
            width: 110px;
            background: #1388ff;
            color: #ffffff;
            .ivu-icon {
              font-size: 22px;
            }
          }
          .ivu-icon {
            font-size: 28px;
            margin-right: 4px;
            margin-top: 1px;
          }
        }

        .advanced-search {
          /deep/ .ivu-select-dropdown {
            border-radius: 0;
          }
        }

        .advanced-search-btn {
          margin: 0 10px;
          height: 34px;
          border-radius: 4px;
          font-size: 16px;
          border: none;
          padding: 0;
          color: #dcdee2;
          text-align: center;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            width: 110px;
            font-size: 16px;
            background: #1388ff;
            color: #ffffff;
            .ivu-icon {
              font-size: 22px;
              margin-right: 2px;
            }
          }
          .ivu-icon {
            font-size: 28px;
          }
        }

        .search-input {
          height: 38px;
          border: none;
          border-radius: 0;
          font-size: 15px;
          color: #333333bf;
          margin: 1px;

          &:focus {
            outline: none;
            border: none;
            box-shadow: none;
          }
        }

        .ketcher-switch {
          .structure-search-btn {
            line-height: 34px;
            border-radius: 4px;
            font-size: 16px;
            border: none;
            padding: 0;
            color: #dcdee2;
            text-align: center;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            .structure-search-icon {
              display: block;
              width: 25px;
              height: 25px;
              background: -235px -6px url(../assets/img/search.png) no-repeat;
              cursor: pointer;
              z-index: 1;
            }
            &.active {
              width: 110px;
              font-size: 16px;
              background: #1388ff;
              color: #ffffff;
              .structure-search-icon {
                width: 20px;
                height: 25px;
                background: -331px -105px url(../assets/img/search.png) no-repeat;
                margin-right: 4px;
              }
            }
          }

          /deep/ .ivu-dropdown-rel {
            height: 37px;
            display: flex;
            align-items: center;
          }

          /deep/ .ivu-select-dropdown[x-placement='bottom-end'] {
            width: 735px;
            height: 530px;
            border: 2px solid #1388ff;
            border-top: none;
            border-radius: 0;
            padding: 1px;
          }

          .ketcher-panel {
            width: 100%;
            height: 456px;
            border: none;
            border-bottom: 1px solid #e4e5e9;
          }

          .ivu-radio-group {
            padding: 0 12px;
            margin: 20px 0 0 10px;
          }

          .search-percent {
            margin-top: 20px;
            width: 60px;
          }

          .ketcher-search-btn {
            padding: 0 12px;
            height: 36px;
            font-size: 16px;
            line-height: 36px;
            border: 1px solid #3288ff;
            color: #ffffff;
            background-color: #1388ff;
            cursor: pointer;
            margin: 14px auto;
            float: right;
            margin-right: 12px;
            border-radius: 0;

            i {
              display: inline-block;
              width: 19px;
              height: 22px;
              background: -331px -107px url(../assets/img/search.png) no-repeat;
              position: relative;
              top: 4px;
              margin-right: 5px;
            }
          }
        }
      }

      .shop-cart {
        background: #f9f9f9;
        border: 1px solid #e5e5e5;
        line-height: 42px;
        font-size: 15px;
        width: 140px;
        margin-top: 38px;
        color: #333;
        text-align: center;
        float: right;

        .cart-ico {
          position: relative;
          margin-right: 5px;
          top: -3px;
          display: inline-block;
          width: 28px;
          height: 24px;
          vertical-align: middle;
          background: url(../assets/img/ico.png) -29px 0;
        }

        &:hover {
          color: #1388fe;

          .cart-ico {
            background-position-x: -59px;
          }
        }
      }
    }

    .breadcrumb {
      line-height: 44px;
      font-size: 16px;
      border-bottom: 1px solid #e9e9e9;
      background-color: #f9f9f9;
      color: #999999;

      a {
        color: #3497ea;
      }

      .ivu-icon-ios-arrow-forward {
        padding: 0 6px;
      }
    }

    .ivu-layout-footer {
      border-top: 1px solid #e9e9e9;
      padding: 0;

      .ivu-row-flex {
        font-size: 15px;
        line-height: 50px;

        .ivu-col:last-child {
          text-align: right;
        }
      }
    }
  }
</style>
